import { fetchWithToken } from "../../interceptors/fetchInterceptor";
import {
  API_MENU_NAMES,
  API_MENU_STRUCT_BY_USER_ID,
  MAIN_URL,
  PORT_FOR_AUTH,
} from "../../constants/constants";
import { GET_MENU_NAMES, GET_MENU_STRUCT_BY_USER_ID, GET_SORTER_MENU_NAMES } from "../types";

export const getMenuStructByUserId = (id) => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_MENU_STRUCT_BY_USER_ID + id);

    const data = await response.json();

    const dataValid = data.map((item) => {
      return {
        ...item,
        chapterActionId: `${item.chapterId}-${item.actionId}`,
      };
    });

    dispatch({
      type: GET_MENU_STRUCT_BY_USER_ID,
      data: dataValid,
    });
  };
};

export const getMenuNames = () => {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT_FOR_AUTH + API_MENU_NAMES);

    const data = await response.json();

    const menuNamesObject = {};

    data.forEach((object) => {
      const menuActionsListObject = {};

      object.menuActionsList.forEach((obj) => {
        menuActionsListObject[obj.sign] = {
          chapterActionId: `${object.id}-${obj.id}`,
        };
      });

      menuNamesObject[object.sign] = {
        id: object.id,
        ...menuActionsListObject,
      };
    });

    dispatch({
      type: GET_SORTER_MENU_NAMES,
      data: menuNamesObject,
    });

    dispatch({
      type: GET_MENU_NAMES,
      data: data,
    });
  };
};
